function ArrowBackOutline({ size }: { size: number }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" height={size} viewBox="0 0 24 24">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4 11.75C4 11.1977 4.44772 10.75 5 10.75H20.0026C20.5549 10.75 21.0026 11.1977 21.0026 11.75C21.0026 12.3023 20.5549 12.75 20.0026 12.75H5C4.44772 12.75 4 12.3023 4 11.75Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.4571 4.29289C12.8476 4.68342 12.8476 5.31658 12.4571 5.70711L6.41421 11.75L12.4571 17.7929C12.8476 18.1834 12.8476 18.8166 12.4571 19.2071C12.0666 19.5976 11.4334 19.5976 11.0429 19.2071L4.29289 12.4571C3.90237 12.0666 3.90237 11.4334 4.29289 11.0429L11.0429 4.29289C11.4334 3.90237 12.0666 3.90237 12.4571 4.29289Z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default ArrowBackOutline;
